unit UserItemListType;
{

/* Initial. */

}

interface

uses
  UserItemType;

type
  TUserItemListType = array of TUserItemType;

implementation

end.
